<template>
  <footer class="footer">
    <div class="footer-bg" :style="{ backgroundImage: `url(${botImg})` }"></div>
    <div class="container">
      <div class="footer-content">
        
        <div class="footer-group">
          <h4 class="group-title">联系我们</h4>
          <div class="group-body">
            <p class="info-item">
              <span class="info-label">院本部地址：</span>
              云南省昆明市官渡区广福路3768号（广福路与珥季路交汇处西北侧）
            </p>
            <p class="info-item">
              <span class="info-label">公交路线：</span>
              31路、174路、185路、C85路、K15路、安宁K2路、Z96路、253路等多路公交，直达宝象河站下车
            </p>           
          </div>
        </div>

        <div class="footer-group">
          <h4 class="group-title">联系方式</h4>
          <div class="group-body contact-grid">
            <div class="contact-col">
              <span class="info-label">邮政编码：</span>650000
            </div>
            <div class="contact-col">
              <span class="info-label">联系电话：</span>13668727281
            </div>
            <div class="contact-col">
              <span class="info-label">传真：</span>0871-65131060
            </div>
          </div>
        </div>

        <div class="footer-group">
          <div class="beian-row">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer" class="beian-link">
              滇ICP备11004220号-1&nbsp;&nbsp;|&nbsp;&nbsp;云卫网审【2011】第029号
            </a>
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noopener noreferrer" class="police-link">
              <img :src="policeImg" alt="公安备案" class="police-icon" />
              滇公网安备 53010202000682号
            </a>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
import botImg from '@/assets/images/bot.png'
import policeImg from '@/assets/images/police.png'

export default {
  name: 'AppFooter',
  data() {
    return {
      botImg,
      policeImg
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  padding: 45px 0 30px;
  position: relative;

  .footer-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center top;
    z-index: 0;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
  }

  .footer-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .footer-group {
    width: 100%;
  }

  .group-title {
    margin: 0 0 8px 0;
    font-size: 15px;
    font-weight: 600;
    color: #4ecdc4;
    letter-spacing: 0.8px;
    line-height: 1.3;
    border-left: 3px solid #4ecdc4;
    padding-left: 10px;
  }

  .group-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .info-item {
    margin: 0;
    font-size: 14px;
    color: #5a5a5a;
    line-height: 1.5;
    text-align: left;
  }

  .info-label {
    font-weight: 500;
    color: #777;
  }

  .contact-grid {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .contact-col {
    font-size: 14px;
    color: #5a5a5a;
    line-height: 1.2;
  }

  .beian-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
    padding-top: 2px;
  }

  .beian-link {
    font-size: 13px;
    color: #777;
    text-decoration: none;
    transition: color 0.25s ease;

    &:hover {
      color: #4ecdc4;
    }
  }

  .police-link {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 13px;
    color: #777;
    text-decoration: none;
    transition: color 0.25s ease;

    &:hover {
      color: #4ecdc4;
    }
  }

  .police-icon {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }
}
</style>
